import HttpService from "../HttpService";

export async function getSecurityFeatures(ctx) {
  try {
    const locale = ctx.store.$i18n.locale;
    const { data } = await HttpService.query()
      .setPath("/view/security-features" + "?lang=" + locale)
      .get();
    return data;
  } catch (e) {
    return null;
  }
}
